import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
 
@Injectable({
  providedIn: 'root'
})
export class DataService {
  private dataSource: BehaviorSubject<any[] | any> = new BehaviorSubject<any[] | any>(false);
  data: Observable<any[] | any> = this.dataSource.asObservable();
 
  constructor() { }
 
  sendData(data: any[]| any) {
    this.dataSource.next(data);
  }
}
 